import { ApiClient } from '@webapp/core/services/ApiClient'
import { TravelTicketRepository } from './TravelTicketRepository'

export const travelTicketRepository = new TravelTicketRepository({
  httpClient: ApiClient,
})

export { TravelTicketRepository }
